/**
 * The letters for a one-based position: a, b, ... z, aa, ab.
 *
 * Bijective base 26 has no zero digit, hence the subtraction: the twenty-sixth
 * position is "z" and the twenty-seventh "aa", where an ordinary base would put
 * a zero and read "ba". Both a figure group's members and a claim's numbered
 * elements are lettered this way, and a sequence that disagreed with itself
 * halfway along would be a formal defect in one of them.
 */
export function bijectiveBase26(position: number): string {
  let letters = "";
  let left = position;
  while (left > 0) {
    const remainder = (left - 1) % 26;
    left = Math.floor((left - 1) / 26);
    letters = String.fromCharCode(97 + remainder) + letters;
  }
  return letters;
}
